var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddtimeicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 21C9.75 21 8.57933 20.7667 7.488 20.3C6.39667 19.8333 5.44233 19.1917 4.625 18.375C3.80833 17.5583 3.16667 16.604 2.7 15.512C2.23333 14.42 2 13.2493 2 12C2 10.75 2.23333 9.57933 2.7 8.488C3.16667 7.39667 3.80833 6.44233 4.625 5.625C5.44167 4.80833 6.396 4.16667 7.488 3.7C8.58 3.23333 9.75067 3 11 3C11.35 3 11.6877 3.021 12.013 3.063C12.3383 3.105 12.6673 3.16733 13 3.25V5.3C12.6667 5.2 12.3377 5.125 12.013 5.075C11.6883 5.025 11.3507 5 11 5C9.03333 5 7.375 5.675 6.025 7.025C4.675 8.375 4 10.0333 4 12C4 13.9667 4.675 15.625 6.025 16.975C7.375 18.325 9.03333 19 11 19C12.9667 19 14.625 18.325 15.975 16.975C17.325 15.625 18 13.9667 18 12C18 11.8167 17.9917 11.65 17.975 11.5C17.9583 11.35 17.9333 11.1833 17.9 11H19.95C19.9833 11.1833 20 11.35 20 11.5V12C20 13.25 19.7667 14.421 19.3 15.513C18.8333 16.605 18.1917 17.559 17.375 18.375C16.5583 19.1917 15.604 19.8333 14.512 20.3C13.42 20.7667 12.2493 21 11 21ZM13.8 16.2L10 12.4V7H12V11.6L15.2 14.8L13.8 16.2ZM18 9V6H15V4H18V1H20V4H23V6H20V9H18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddtimeicon);
export default __webpack_public_path__ + "static/media/addtime.icon.52bd6de8f8a84864dd43ee458536cd4c.svg";
export { ForwardRef as ReactComponent };